export const NORMAS_ORDER = ['LTSV', 'RGCIR', 'RGCON', 'RGVEH', 'SOA', 'REPC'];
//# sourceMappingURL=types.js.map